const routes = [
  {
    path: '/areaConfig', // 摄像机设备列表页面入口
    name: 'areaConfig',
    component: () => import('./pages/Home'),
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index', // 摄像机设备列表页面
        name: 'areaConfigIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false
        }
      }
    ]
  }
]

export default routes